export default __webpack_public_path__ + "static/media/logo_ice.8d31260e.svg";